function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11.571,
    viewBox: "0 0 15 11.571",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14 5H5a3.081 3.081 0 0 0-1.95.675A3.075 3.075 0 0 0 2 8v5.571a3.009 3.009 0 0 0 3 3h9a3.009 3.009 0 0 0 3-3V8a3.075 3.075 0 0 0-1.05-2.325A3.081 3.081 0 0 0 14 5zm0 1.5-3.75 2.925a1.243 1.243 0 0 1-1.575 0L5 6.5zm1.5 7.071a1.5 1.5 0 0 1-1.5 1.5H5a1.5 1.5 0 0 1-1.5-1.5V8a2.19 2.19 0 0 1 .15-.675l4.125 3.3a3 3 0 0 0 1.725.6 3 3 0 0 0 1.725-.6l4.125-3.3A2.19 2.19 0 0 1 15.5 8z",
    transform: "translate(-2 -5)",
    style: {
      fill: "#c4c4c4"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email.46057586.svg";
export { ForwardRef as ReactComponent };